import { DateTime, Duration } from 'luxon';
import i18n from '@/i18n';

/* Add number of minutes in date */
export function addSec(date, sec) {
  return DateTime.fromJSDate(date).plus(Duration.fromObject({ seconds: sec })).toJSDate();
}
/* Get hour of date rounded on nearest */
export function roundHour(timestamp) {
  return Math.round(timestamp / (3600 * 1000));
}
export function roundHalfHour(timestamp) {
  let source = timestamp / (3600 * 1000);
  const hour = Math.trunc(timestamp / (3600 * 1000));
  source -= hour;
  source = Math.round(source * 100);

  let half = 0;
  if (source < 25) {
    half = 0;
  } else if (source < 75) {
    half = 0.5;
  } else {
    half = 1;
  }
  return hour + half;
}
export function noRounded(timestamp) {
  return timestamp / (3600 * 1000);
}

export function isToday(d) {
  return d.toFormat('yyyy-LL-dd') === DateTime.now().toFormat('yyyy-LL-dd');
}

/* Format the date in string hh:mm */
export function formatTime(date) {
  return DateTime.fromJSDate(date).toFormat('HH:mm');
}

export function formatDateTime(date) {
  return DateTime.fromJSDate(date).toFormat('dd.LL.yyyy - HH:mm');
}

export function toHoursMinutesFormat(dateTime) {
  return dateTime.toFormat('HH:mm');
}

export function toShortDateFormat(dateTime) {
  return dateTime.toLocaleString(DateTime.DATE_SHORT, { locale: i18n.locale });
}

export function printDateFormat(dateTime) {
  return dateTime.toFormat('ccc dd.MM.yyyy', { locale: i18n.locale });
}

export function toHugeDateTimeFormat(dateTime) {
  return dateTime.toLocaleString(DateTime.DATETIME_HUGE, { locale: i18n.locale });
}

export function toHugeDateFormat(dateTime) {
  return dateTime.toLocaleString(DateTime.DATE_HUGE, { locale: i18n.locale });
}

/* Transform timestamp to date object */
export function getDateFromTimestamp(timestamp, eventTimeZone) {
  return DateTime.fromMillis(timestamp).setZone(eventTimeZone);
}

export function getTimestampFromDate(date) {
  return date.toMillis();
}


export function millisToHoursAndMinutes(millis) {
  let hours = Math.floor(millis / (3600 * 1000));
  const minutesInMs = millis - (hours * (3600 * 1000));
  let minutes = Math.round(minutesInMs / (60 * 1000));
  hours = (hours < 10) ? `0${hours}` : hours;
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  return `${hours}:${minutes}`;
}

export function secToHoursAndMinutes(sec) {
  let totalSeconds = sec;
  let hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let minutes = Math.floor(totalSeconds / 60);
  hours = (hours < 10) ? `0${hours}` : parseFloat(hours).toLocaleString('fr');
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  return `${hours}:${minutes}`;
}

export function secToHoursAndMinutesWithExtraDay(sec) {
  let totalSeconds = sec;
  let hours = Math.floor(totalSeconds / 3600);
  totalSeconds %= 3600;
  let minutes = Math.floor(totalSeconds / 60);
  let extraDay = false;
  if (hours >= 24) {
    extraDay = true;
    hours -= 24;
  }
  hours = (hours < 10) ? `0${hours}` : parseFloat(hours).toLocaleString('fr');
  minutes = (minutes < 10) ? `0${minutes}` : minutes;
  return extraDay ? `${hours}:${minutes} +1` :  `${hours}:${minutes}`;
}


export function isInclude(array, item) {
  // FOR FUCKING IE
  if (!Array.prototype.includes) {
    array.forEach((currentItem) => {
      if (currentItem === item) {
        return true;
      }
    });
    return false;
  }
  return array.includes(item);
}

/* GROUP BY FOR AN ARRAY */
export function groupBy(array, key) {
  const result = {};
  array.forEach((item) => {
    if (!result[item[key]] && item[key] !== '') {
      result[item[key]] = [];
    }

    if (item[key] !== '') {
      result[item[key]].push(item);
    }
  });
  return result;
}
export function groupByMultipleKeys(array, keys) {
  const result = {};

  array.forEach((item) => {
    let key = '';
    keys.forEach((k) => {
      if (key === '') {
        key += item[k];
      } else {
        key += `-${item[k]}`;
      }
    });
    if (key !== '') {
      if (!result[key]) {
        result[key] = [];
      }

      result[key].push(item);
    }
  });

  return result;
}

export function groupByReferenceKeyWithSubKeys(array, refKey, subkeys) {
  const result = {};


  array.forEach((item) => {
    if (!result[item[refKey]] && item[refKey] !== '') {
      result[item[refKey]] = {};
    }
    // const dict = result[item[refKey]];

    if (item[refKey] !== '') {
      // Create subkey index
      let subkey = '';
      subkeys.forEach((k) => {
        if (subkey === '') {
          subkey += item[k];
        } else {
          subkey += `-${item[k]}`;
        }
      });

      // Test if subkey index already present
      if (!result[item[refKey]][subkey]) {
        result[item[refKey]][subkey] = [];
      }
      result[item[refKey]][subkey].push(item);
    }
  });

  return result;
}


export function reorderArray(event, originalArray) {
  const movedItem = originalArray.find((item, index) => index === event.oldIndex);
  if (movedItem) {
    const remainingItems = originalArray.filter((item, index) => index !== event.oldIndex);
    
    const reorderedItems = [
      ...remainingItems.slice(0, event.newIndex),
      movedItem,
      ...remainingItems.slice(event.newIndex)
    ];

    return reorderedItems;
  }
  return originalArray;
}


export function isMobile() {
  let check = false;
  (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; }(navigator.userAgent || navigator.vendor || window.opera));
  return check;
}

export function getProgressVariant(prc) {
  if (prc < 50) {
    return 'danger';
  } else if (prc >= 50 && prc <= 75) {
    return 'warning';
  } else if (prc > 75 && prc <= 95) {
    return 'info';
  } else if (prc > 95) {
    return 'success';
  }
  return 'dark';
}


function getRGB(c) {
  return parseInt(c, 16) || c
}

function getsRGB(c) {
  return getRGB(c) / 255 <= 0.03928
    ? getRGB(c) / 255 / 12.92
    : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4)
}

function getLuminance(hexColor) {
  return (
    0.2126 * getsRGB(hexColor.substr(1, 2)) +
    0.7152 * getsRGB(hexColor.substr(3, 2)) +
    0.0722 * getsRGB(hexColor.substr(-2))
  )
}

function getContrast(f, b) {
  const L1 = getLuminance(f)
  const L2 = getLuminance(b)
  return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
}

export function getTextColor(bgColor) {
  const whiteContrast = getContrast(bgColor, '#ffffff')
  const blackContrast = getContrast(bgColor, '#000000')

  return whiteContrast > blackContrast ? '#ffffff' : '#000000'
}
